<template>
  <client-only>
    <v-layout text-left>
      <v-dialog
        v-model="dialog"
        max-width="400px"
        content-class="password-reset"
      >
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-btn
                color="black darken-1"
                class="closeBtn"
                text
                @click.native="
                  dialog = false;
                  resetSent = false;
                "
              >
                X
              </v-btn>
              <v-layout wrap>
                <v-flex xs12>
                  <p v-show="!resetSent" class="font-weight-medium">
                    כתובת האימייל איתה נרשמת למערכת:
                  </p>
                </v-flex>

                <v-flex v-show="resetSent">
                  <p class="font-weight-medium">{{ confirmationReset }}</p>
                </v-flex>

                <v-flex xs12>
                  <v-form
                    v-show="!resetSent"
                    id="password-reset-form"
                    ref="form"
                    v-model="valid"
                    class="login-menu-wrapper"
                    action
                    lazy-validation
                  >
                    <v-text-field
                      id="email-reset"
                      v-model="email"
                      :value="email"
                      dense
                      outlined
                      solo
                      :rules="emailRules"
                      type="email"
                      label="דואר אלקטרוני"
                      prepend-inner-icon="mdi-email-outline"
                      class="text-field-input ltr"
                      required
                    />
                  </v-form>
                </v-flex>
                <v-flex v-show="!resetSent" xs12 text-center>
                  <v-btn
                    :disabled="!valid"
                    class="orange_btn_narrow mb-2"
                    :loading="inProcess"
                    @click="resetPassword"
                  >
                    {{ resetTxt }}
                  </v-btn>
                  <div>
                    <small>{{ passwordReset }}</small>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </client-only>
</template>

<script>
import { t } from '@/store/modules/homeDrushim/constantsContent';
import { emailRules } from '@/lib/rules.js';
import { RESET_PASSWORD } from '@/lib/api.js';
export default {
  props: {
    resetEmail: {
      type: String,
      default: '',
      required: false,
    },
  },
  data: () => ({
    resetSent: false,
    dialog: false,
    valid: false,
    inProcess: false,
    passwordReset: t('titles.passwordReset'),
    confirmationReset: t('titles.confirmationReset'),
    resetTxt: t('titles.resetTxt'),
    email: '',
    emailRules,
  }),

  mounted() {
    this.$bus.$on('passwordReset', this.mailReset);
  },

  beforeDestroy() {
    this.$bus.$off('passwordReset');
  },
  methods: {
    mailReset(_email) {
      this.email = _email;
      this.dialog = true;
    },
    async resetPassword() {
      if (this.$refs.form.validate()) {
        this.confirmationReset = '';
        this.inProcess = true;
        this.$nuxt.$loading.start();
        try {
          await this.$axios
            .post(`${RESET_PASSWORD}`, '"' + this.email + '"')

            .then((res) => {
              if (res.data.IsError) {
                this.$nuxt.$loading.finish();

                if (res.data.Errors.UserNotExists) {
                  this.confirmationReset = t('titles.emailNotExists');
                  this.resetSent = true;
                  this.inProcess = false;
                  throw t('titles.emailNotExists');
                }

                this.confirmationReset = t('titles.systemError');
                this.resetSent = true;
                this.inProcess = false;
                throw t('titles.systemError');
              }

              this.$nuxt.$loading.finish();
              this.confirmationReset = t('titles.confirmationReset');
              this.resetSent = true;
              this.inProcess = false;
            });
        } catch (e) {
          console.log('error', e);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-dialog.password-reset {
  z-index: 2400 !important;
}

.closeBtn {
  color: #000;
  font-weight: 400;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 18px;
}
</style>
